module.exports = __webpack_public_path__ + "static/media/country_cc.25981168.webp";